<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
        WebShell
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WSFinder</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">WebShell 상세 정보</a>
        </li>
      </ul>
    </div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              {{model.name}}
            </div>
            <div class="mt7">
              <span class="float-right">{{model.created_at | datetime}}</span>
            </div>
          </div>
          <hr>
          <b-row class="mb-2">
            <b-col md="4">
              <b-form-group>
                <label class="col-form-label" for="ph_category" style="border-bottom: 2px solid;">HASH(MD5)</label>
                <div class="ql-snow" v-html="model.md5"></div>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label class="col-form-label" for="ph_title" style="border-bottom: 2px solid;">파일 이름</label>
                <div class="ql-snow" v-html="model.name"></div>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label class="col-form-label" for="ph_title" style="border-bottom: 2px solid;">SSDEEP</label>
                <div class="ql-snow" v-html="model.ssdeep"></div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="4">
              <b-form-group>
                <label class="col-form-label" for="ph_title" style="border-bottom: 2px solid;">분류</label>
                <div class="ql-snow" v-html="codes.code_category[model.category] || 'Webshell'"></div>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label class="col-form-label" for="ph_title" style="border-bottom: 2px solid;">확장자</label>
                <div class="ql-snow" v-html="model.ext"></div>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label class="col-form-label" for="ph_title" style="border-bottom: 2px solid;">출처</label>
                <div class="ql-snow" v-html="model.source || 'F1Security'"></div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col class="">
              <b-form-group>
                <div style="max-height: 500px; overflow: auto; background-color:#f5f5f5; border:1px solid #ccc; padding:10px; border-radius: 5px;">
                  {{(model.is_binary) ? model.data : '파일 내용 확인'}}
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-button size="sm" variant="add" @click="download" style="margin:0 5px;"> 다운로드 </b-button>
          <b-button size="sm" variant="danger" @click="confirm = true" style="margin:0 5px;" :disabled="model.is_del"> 삭제 </b-button>
          <!-- <input id="ph_title" type="checkbox" v-model="pattern_del">
          <label for="ph_title"> 패턴삭제</label> -->
          <b-button size="sm" class="float-right" variant="primary" @click="list"> 목록 </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-modal title="삭제 안내"  class="modal-danger" v-model="confirm" @ok="remove" ok-variant="outline-danger" cancel-variant="outline-dark" ok-title="확인" cancel-title="취소" header-bg-variant="danger">
      WebShell을 삭제하시겠습니까?
    </b-modal>
</div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>